/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventResponseRecordsInner } from './EventResponseRecordsInner';
import {
    EventResponseRecordsInnerFromJSON,
    EventResponseRecordsInnerFromJSONTyped,
    EventResponseRecordsInnerToJSON,
} from './EventResponseRecordsInner';

/**
 * 
 * @export
 * @interface EventResponse
 */
export interface EventResponse {
    /**
     * 
     * @type {Array<EventResponseRecordsInner>}
     * @memberof EventResponse
     */
    records?: Array<EventResponseRecordsInner>;
}

/**
 * Check if a given object implements the EventResponse interface.
 */
export function instanceOfEventResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventResponseFromJSON(json: any): EventResponse {
    return EventResponseFromJSONTyped(json, false);
}

export function EventResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(EventResponseRecordsInnerFromJSON)),
    };
}

export function EventResponseToJSON(value?: EventResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(EventResponseRecordsInnerToJSON)),
    };
}

